import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "small" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Document"),
    /*#__PURE__*/_createElementVNode("th", null, "Web Submission Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Status")
  ])
], -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    ($props.documents.length > 0)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.documents, (document) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "large",
              key: document.DocumentID
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("a", {
                  href: "javascript;",
                  onClick: _withModifiers(($event: any) => ($setup.openModal('smartsearch', null, 'modal-success', null, { DocumentID: document.DocumentID })), ["prevent"])
                }, _toDisplayString(document.Type), 9, _hoisted_4)
              ]),
              _createElementVNode("td", null, _toDisplayString(new Date(document.Date).toLocaleDateString()), 1),
              _createElementVNode("td", null, _toDisplayString(document.Status), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}